<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <div *ngIf="successMessage"
        class="mb-5 p-4 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-700 flex items-center gap-2 text-sm font-semibold">
        <span class="material-symbols-outlined text-[20px]">check_circle</span>
        {{ successMessage }}
    </div>

    <div *ngIf="errorMessage"
        class="mb-5 p-4 rounded-xl bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm font-semibold">
        <span class="material-symbols-outlined text-[20px]">error</span>
        {{ errorMessage }}
    </div>

    <section class="mb-7 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
            <p class="text-xs font-bold uppercase tracking-[0.18em] text-blue-700">Public enquiries</p>
            <h1 class="mt-2 text-2xl font-bold text-slate-900">Contact Message Review</h1>
            <p class="mt-2 max-w-2xl text-sm text-slate-500">
                Review messages submitted from the public contact form and mark completed enquiries as resolved.
            </p>
        </div>

        <button type="button" (click)="loadMessages()"
            class="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50">
            <span class="material-symbols-outlined text-[19px]">refresh</span>
            Refresh
        </button>
    </section>

    <section class="mb-7 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <article class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <div class="flex items-center justify-between">
                <div>
                    <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Total messages</p>
                    <p class="mt-2 text-3xl font-bold text-slate-900">{{ totalCount }}</p>
                </div>
                <div class="rounded-xl bg-blue-50 p-3 text-blue-700">
                    <span class="material-symbols-outlined">inbox</span>
                </div>
            </div>
        </article>

        <article class="rounded-2xl border border-amber-200 bg-amber-50 p-5 shadow-sm">
            <div class="flex items-center justify-between">
                <div>
                    <p class="text-xs font-bold uppercase tracking-wider text-amber-700">Needs review</p>
                    <p class="mt-2 text-3xl font-bold text-amber-900">{{ pendingCount }}</p>
                </div>
                <div class="rounded-xl bg-white/80 p-3 text-amber-700">
                    <span class="material-symbols-outlined">pending_actions</span>
                </div>
            </div>
        </article>

        <article class="rounded-2xl border border-emerald-200 bg-emerald-50 p-5 shadow-sm">
            <div class="flex items-center justify-between">
                <div>
                    <p class="text-xs font-bold uppercase tracking-wider text-emerald-700">Resolved</p>
                    <p class="mt-2 text-3xl font-bold text-emerald-900">{{ resolvedCount }}</p>
                </div>
                <div class="rounded-xl bg-white/80 p-3 text-emerald-700">
                    <span class="material-symbols-outlined">task_alt</span>
                </div>
            </div>
        </article>

        <article class="rounded-2xl border border-violet-200 bg-violet-50 p-5 shadow-sm">
            <div class="flex items-center justify-between">
                <div>
                    <p class="text-xs font-bold uppercase tracking-wider text-violet-700">Received today</p>
                    <p class="mt-2 text-3xl font-bold text-violet-900">{{ todayCount }}</p>
                </div>
                <div class="rounded-xl bg-white/80 p-3 text-violet-700">
                    <span class="material-symbols-outlined">today</span>
                </div>
            </div>
        </article>
    </section>

    <section class="mb-5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div class="relative w-full lg:max-w-xl">
                <span
                    class="material-symbols-outlined absolute left-3.5 top-1/2 -translate-y-1/2 text-[20px] text-slate-400">
                    search
                </span>
                <input type="text" [(ngModel)]="searchText" (ngModelChange)="applyFilters()"
                    placeholder="Search name, email, subject, or message"
                    class="w-full rounded-xl border border-slate-300 py-2.5 pl-11 pr-4 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100" />
            </div>

            <div class="flex flex-wrap items-center gap-2">
                <button type="button" (click)="setStatusFilter('all')"
                    class="rounded-lg px-4 py-2 text-sm font-bold transition"
                    [ngClass]="statusFilter === 'all' ? 'bg-blue-900 text-white shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'">
                    All
                </button>
                <button type="button" (click)="setStatusFilter('pending')"
                    class="rounded-lg px-4 py-2 text-sm font-bold transition"
                    [ngClass]="statusFilter === 'pending' ? 'bg-amber-500 text-white shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'">
                    Needs Review
                </button>
                <button type="button" (click)="setStatusFilter('resolved')"
                    class="rounded-lg px-4 py-2 text-sm font-bold transition"
                    [ngClass]="statusFilter === 'resolved' ? 'bg-emerald-600 text-white shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'">
                    Resolved
                </button>
                <button type="button" (click)="resetFilters()"
                    class="inline-flex items-center justify-center rounded-lg p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
                    title="Reset filters">
                    <span class="material-symbols-outlined text-[20px]">restart_alt</span>
                </button>
            </div>
        </div>
    </section>

    <section class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
            <table class="w-full min-w-[960px] text-left border-collapse">
                <thead>
                    <tr class="border-b border-slate-200 bg-slate-50">
                        <th class="px-5 py-3.5 text-xs font-bold uppercase tracking-wider text-slate-500">Sender</th>
                        <th class="px-5 py-3.5 text-xs font-bold uppercase tracking-wider text-slate-500">Subject</th>
                        <th class="px-5 py-3.5 text-xs font-bold uppercase tracking-wider text-slate-500">Received</th>
                        <th class="px-5 py-3.5 text-xs font-bold uppercase tracking-wider text-slate-500">Status</th>
                        <th class="px-5 py-3.5 text-right text-xs font-bold uppercase tracking-wider text-slate-500">Actions</th>
                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-100">
                    <tr *ngFor="let obj of pagedMessages; trackBy: trackByMessageId"
                        class="transition-colors hover:bg-slate-50/80"
                        [class.bg-amber-50]="!obj.isSolved">
                        <td class="px-5 py-4">
                            <div class="flex items-center gap-3">
                                <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-bold"
                                    [ngClass]="obj.isSolved ? 'bg-slate-100 text-slate-500' : 'bg-blue-100 text-blue-700'">
                                    {{ (obj.fullName || '?').charAt(0).toUpperCase() }}
                                </div>
                                <div class="min-w-0">
                                    <p class="truncate text-sm font-bold text-slate-800">{{ obj.fullName || 'Unknown sender' }}</p>
                                    <a *ngIf="obj.email; else noEmail" [href]="'mailto:' + obj.email"
                                        class="block truncate text-xs text-blue-700 hover:underline">
                                        {{ obj.email }}
                                    </a>
                                    <ng-template #noEmail>
                                        <span class="text-xs text-slate-400">No email address</span>
                                    </ng-template>
                                </div>
                            </div>
                        </td>

                        <td class="px-5 py-4">
                            <p class="max-w-[420px] truncate text-sm font-semibold text-slate-700">
                                {{ obj.subject || 'No subject' }}
                            </p>
                            <p class="mt-1 max-w-[420px] truncate text-xs text-slate-400">
                                {{ obj.message || 'No message content' }}
                            </p>
                        </td>

                        <td class="px-5 py-4 text-sm text-slate-600">
                            <div>{{ obj.createdAt | date:'dd MMM yyyy' }}</div>
                            <div class="mt-0.5 text-xs text-slate-400">{{ obj.createdAt | date:'HH:mm' }}</div>
                        </td>

                        <td class="px-5 py-4">
                            <span class="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold"
                                [ngClass]="obj.isSolved ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'">
                                <span class="h-1.5 w-1.5 rounded-full"
                                    [ngClass]="obj.isSolved ? 'bg-emerald-500' : 'bg-amber-500'"></span>
                                {{ obj.isSolved ? 'Resolved' : 'Needs Review' }}
                            </span>
                        </td>

                        <td class="px-5 py-4 text-right">
                            <div class="flex justify-end gap-1">
                                <button type="button"
                                    class="rounded-lg p-2 text-slate-400 transition hover:bg-blue-50 hover:text-blue-700"
                                    (click)="viewData(obj.contactMessageId)" title="Review message">
                                    <span class="material-symbols-outlined text-[20px]">visibility</span>
                                </button>

                                <a *ngIf="obj.email" [href]="getReplyHref(obj)"
                                    class="rounded-lg p-2 text-slate-400 transition hover:bg-violet-50 hover:text-violet-700"
                                    title="Reply by email">
                                    <span class="material-symbols-outlined text-[20px]">reply</span>
                                </a>

                                <button type="button" *ngIf="!obj.isSolved"
                                    class="rounded-lg p-2 text-slate-400 transition hover:bg-emerald-50 hover:text-emerald-700 disabled:opacity-50"
                                    [disabled]="resolvingMessageId === obj.contactMessageId"
                                    (click)="resolveMessage(obj)" title="Mark resolved">
                                    <span class="material-symbols-outlined text-[20px]">
                                        {{ resolvingMessageId === obj.contactMessageId ? 'progress_activity' : 'task_alt' }}
                                    </span>
                                </button>

                                <button type="button"
                                    class="rounded-lg p-2 text-slate-400 transition hover:bg-red-50 hover:text-red-600 disabled:opacity-50"
                                    [disabled]="deletingMessageId === obj.contactMessageId"
                                    (click)="deleteMessage(obj)" title="Delete message">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="pagedMessages.length === 0">
                        <td colspan="5" class="px-6 py-16 text-center">
                            <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-slate-400">
                                <span class="material-symbols-outlined text-[30px]">inbox</span>
                            </div>
                            <h3 class="mt-4 text-sm font-bold text-slate-700">No contact messages found</h3>
                            <p class="mt-1 text-sm text-slate-400">Try changing the search or status filter.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="flex flex-col gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
            <p class="text-xs font-semibold text-slate-500">
                Showing {{ pagedMessages.length }} of {{ filteredMessages.length }} messages
            </p>

            <div class="flex flex-wrap justify-center gap-2">
                <button type="button" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40">
                    Previous
                </button>

                <button type="button" *ngFor="let page of pageNumbers" (click)="changePage(page)"
                    class="min-w-10 rounded-lg border px-3 py-2 text-sm font-bold transition"
                    [ngClass]="currentPage === page ? 'border-blue-900 bg-blue-900 text-white' : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-100'">
                    {{ page }}
                </button>

                <button type="button" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages()"
                    class="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40">
                    Next
                </button>
            </div>
        </div>
    </section>
</main>

<div *ngIf="isModalOpen && selectedMessage"
    class="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/55 px-4 py-6 backdrop-blur-sm"
    (click)="closeModal()">
    <section class="flex max-h-[calc(100vh-48px)] w-full max-w-[760px] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl"
        (click)="$event.stopPropagation()">

        <header class="flex items-start justify-between gap-4 border-b border-slate-200 bg-slate-50 px-6 py-5">
            <div class="flex min-w-0 items-start gap-3">
                <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl"
                    [ngClass]="selectedMessage.isSolved ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'">
                    <span class="material-symbols-outlined">contact_mail</span>
                </div>
                <div class="min-w-0">
                    <div class="flex flex-wrap items-center gap-2">
                        <h2 class="text-lg font-bold text-slate-900">Contact Message</h2>
                        <span class="rounded-full px-2.5 py-1 text-[11px] font-bold"
                            [ngClass]="selectedMessage.isSolved ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'">
                            {{ selectedMessage.isSolved ? 'Resolved' : 'Needs Review' }}
                        </span>
                    </div>
                    <p class="mt-1 truncate text-sm text-slate-500">
                        Received {{ selectedMessage.createdAt | date:'dd MMM yyyy, HH:mm' }}
                    </p>
                </div>
            </div>

            <button type="button" class="rounded-lg p-2 text-slate-400 transition hover:bg-slate-200 hover:text-slate-700"
                (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>
        </header>

        <div class="flex-1 overflow-y-auto px-6 py-6">
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div class="rounded-xl border border-slate-200 bg-slate-50 p-4">
                    <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Sender</p>
                    <p class="mt-2 text-sm font-bold text-slate-800">{{ selectedMessage.fullName || 'Unknown sender' }}</p>
                </div>

                <div class="rounded-xl border border-slate-200 bg-slate-50 p-4">
                    <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Email address</p>
                    <a *ngIf="selectedMessage.email; else modalNoEmail" [href]="'mailto:' + selectedMessage.email"
                        class="mt-2 block break-all text-sm font-bold text-blue-700 hover:underline">
                        {{ selectedMessage.email }}
                    </a>
                    <ng-template #modalNoEmail>
                        <p class="mt-2 text-sm text-slate-500">Not provided</p>
                    </ng-template>
                </div>
            </div>

            <div class="mt-5">
                <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Subject</p>
                <h3 class="mt-2 text-lg font-bold text-slate-900">{{ selectedMessage.subject || 'No subject' }}</h3>
            </div>

            <div class="mt-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <p class="text-xs font-bold uppercase tracking-wider text-slate-400">Message</p>
                <p class="mt-3 whitespace-pre-wrap break-words text-sm leading-7 text-slate-700">
                    {{ selectedMessage.message || 'No message content' }}
                </p>
            </div>

            <div *ngIf="selectedMessage.isSolved"
                class="mt-5 flex items-start gap-3 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-800">
                <span class="material-symbols-outlined text-[21px]">verified</span>
                <div>
                    <p class="text-sm font-bold">This enquiry has been resolved.</p>
                    <p class="mt-1 text-xs text-emerald-700" *ngIf="selectedMessage.solvedAt">
                        Resolved on {{ selectedMessage.solvedAt | date:'dd MMM yyyy, HH:mm' }}
                    </p>
                </div>
            </div>
        </div>

        <footer class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
            <button type="button" (click)="deleteMessage(selectedMessage)"
                class="inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold text-red-600 transition hover:bg-red-100">
                <span class="material-symbols-outlined text-[19px]">delete</span>
                Delete
            </button>

            <div class="flex flex-col gap-2 sm:flex-row">
                <a *ngIf="selectedMessage.email"
                    [href]="getReplyHref(selectedMessage)"
                    class="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-5 py-2.5 text-sm font-bold text-slate-700 transition hover:bg-slate-100">
                    <span class="material-symbols-outlined text-[19px]">reply</span>
                    Reply by Email
                </a>

                <button type="button" *ngIf="!selectedMessage.isSolved"
                    (click)="resolveMessage(selectedMessage)"
                    [disabled]="resolvingMessageId === selectedMessage.contactMessageId"
                    class="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-600 px-5 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-emerald-700 disabled:opacity-50">
                    <span class="material-symbols-outlined text-[19px]">task_alt</span>
                    {{ resolvingMessageId === selectedMessage.contactMessageId ? 'Resolving...' : 'Mark Resolved' }}
                </button>
            </div>
        </footer>
    </section>
</div>
